import { render, staticRenderFns } from "./AddInPPTModal.vue?vue&type=template&id=061bcf4a&scoped=true&"
import script from "./AddInPPTModal.vue?vue&type=script&lang=js&"
export * from "./AddInPPTModal.vue?vue&type=script&lang=js&"
import style0 from "./AddInPPTModal.vue?vue&type=style&index=0&id=061bcf4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061bcf4a",
  null
  
)

export default component.exports